import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('exportDropdown');

    return {
        EXPORT: t('export'),
        EXPORT_ERROR: t('exportError'),
        EXPORT_KML: t('exportKml'),
        EXPORT_PDF: t('exportPdf'),
        EXPORT_PDF_FAILED: t('exportPdfFailed'),
        NO_FLIGHTS_TO_EXPORT: t('noFlightsToExport'),
        SPRAY: t('spray'),
        SPREAD: t('spread'),
        TOO_MANY_FLIGHTS: t('tooManyFlights'),
        UNKNOWN: t('unknown')
    };
};

export default useTranslation;
